// Lưu nội dung file đính kèm vào IndexedDB (localStorage không đủ dung lượng). Metadata nằm trong store.
const DB_NAME = 'khothi-docs-files';
const STORE = 'files';

let dbPromise: Promise<IDBDatabase> | null = null;

function openDb(): Promise<IDBDatabase> {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = () => req.result.createObjectStore(STORE);
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => { dbPromise = null; reject(req.error); };
    });
  }
  return dbPromise;
}

function tx<T>(mode: IDBTransactionMode, run: (s: IDBObjectStore) => IDBRequest<T> | void): Promise<T | undefined> {
  return openDb().then(db => new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = run(t.objectStore(STORE));
    t.oncomplete = () => resolve(req ? req.result : undefined);
    t.onerror = () => reject(t.error);
  }));
}

export const putFile = (id: string, blob: Blob) => tx('readwrite', s => s.put(blob, id));
export const getFile = (id: string) => tx<Blob>('readonly', s => s.get(id)).catch(() => undefined);
export const deleteFiles = (ids: string[]) =>
  ids.length ? tx('readwrite', s => { ids.forEach(id => s.delete(id)); }).catch(() => undefined) : Promise.resolve(undefined);
export const clearFiles = () => tx('readwrite', s => s.clear()).catch(() => undefined);
